var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operator-info"},[_c('img',{staticClass:"success_icon",attrs:{"src":require("@/assets/images/zpcommon/success.png")}}),_vm._t("info",function(){return [_vm._m(0)]})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('p',{staticClass:"big"},[_vm._v("申请已提交成功！")]),_c('p',[_vm._v("请耐心等待客服的审核")])])
}]

export { render, staticRenderFns }